export default "__VITE_ASSET__DGqibRib__"